// extracted by mini-css-extract-plugin
export default {"recos":"g6-z","productCardOverride":"h6-z","rowHasBadge":"i6-z"};